import client from "./client";

const PromoService = {};

PromoService.get = function (data) {
  return client.get(`/promo`, data);
};

PromoService.create = function (data) {
  return client.post(`/promo/`, data);
};

PromoService.update = function (promoId, data) {
  return client.put(`/promo/${promoId}`, data);
};

PromoService.delete = function (promoId) {
  return client.del(`/promo/${promoId}`);
};

export default PromoService;
